import __request__ from "routing/request";
export function providers(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.llm/providers", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteConfig(requestOptions) {
  return __request__("DELETE", "/plugins/org.graylog.plugins.llm/providers/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function saveConfig(config, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.llm/providers/config", config, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getConfig(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.llm/providers/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function test(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.llm/providers/test", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listModels(provider, credentials, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.llm/providers/${provider}/models`, credentials, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
